import { Box, Grid, styled } from '@material-ui/core';
import { TextColor } from '@setvi/shared/enums';

export const Container = styled(Box)(() => ({
  width: '100%',
  // height: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  background:
    'linear-gradient(155deg, #001222 2%, #003A6C  25%,  #3896E0  85%, #1E96FC  100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  display: 'flex',
  alignItems: 'center',
  gap: 6
}));

export const PDFName = styled(Box)(({ theme }) => ({
  gap: 8,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderBottom: `1px solid ${theme.palette.primary.main}`
}));

export const Item = styled(Box)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  padding: '10px',
  borderRadius: '8px',
  fontSize: '15px',
  flexShrink: 0,
  color: TextColor.DarkGrey,
  transition: 'all 0.2s',
  cursor: 'pointer',
  border: '1px solid transparent',
  height: '50px',
  display: 'flex',
  alignItems: 'center',

  // Smaller screens get reduced height
  [theme.breakpoints.down('md')]: {
    height: 'auto'
  },

  '&:hover': {
    borderColor: TextColor.DarkGrey
  }
}));

export const ScrollableGrid = styled(Grid)(({ theme }) => ({
  overflow: 'hidden auto',
  marginLeft: 10,
  overflowY: 'auto',
  maxHeight: '40vh',

  // Smaller screens get reduced height
  [theme.breakpoints.down('md')]: {
    maxHeight: '20vh'
  }
}));
